import * as React from 'react'

import { AppQuery_ipLocation as IpLocation, AppQuery_user as User } from './__generated__/AppQuery'

export interface IAppContext {
  user: User | null
  setUser: (user: User | null) => void
  ipLocation: IpLocation | null
  setIpLocation: (ipLocation: IpLocation | null) => void
}

const AppContext = React.createContext<IAppContext>({
  user: null,
  setUser: _ => null,
  ipLocation: null,
  setIpLocation: _ => null,
})

export default AppContext
